import React from 'react'
import { BsBook } from 'react-icons/bs'
import { CgCommunity } from 'react-icons/cg'
import { ImLocation } from 'react-icons/im'
import { AiTwotoneHome } from 'react-icons/ai'
import { GrStatusCritical } from 'react-icons/gr'

function Background({ match }) {

    return (
        <>
            <div className='d-flex'>
                <BsBook className='match-detail-icon' />
                <div className='match-detail-title'>Background</div>
            </div>
            <div className='d-flex match-detail-info'>
                <div>
                    <div>
                        <GrStatusCritical style={{ color: "purple" }} size={20} />
                        <span style={{ marginLeft: 20 }}>{match?.personalDetails?.residencyStatus}</span>
                    </div>
                    <div>
                        <BsBook style={{ color: "blue" }} size={20} />
                        <span style={{ marginLeft: 20 }}>{match?.personalDetails?.religion}</span>
                    </div>
                    <div>
                        <CgCommunity style={{ color: "grey" }} size={20} />
                        <span style={{ marginLeft: 20 }}>{match?.personalDetails?.community}</span>
                    </div>
                    <div>
                        <ImLocation style={{ color: "purple" }} size={20} />
                        <span style={{ marginLeft: 20 }}>Lives in {match?.personalDetails?.cityLiving}, {match?.personalDetails?.countryLiving}</span>
                    </div>
                    <div>
                        <AiTwotoneHome style={{ color: "orange" }} size={20} />
                        <span style={{ marginLeft: 20 }}>Grew Up In {match?.personalDetails?.grewUpIn}</span>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Background